import Vue from 'vue'
import VueRouter from 'vue-router'
import auth from '@/helpers/auth'

Vue.use(VueRouter)

const isAuth = (to, from, next) => {
	if (!auth.loggedIn()) {
		next({
			name: 'login',
			query: { redirect: to.fullPath },
		});
	} else {
		next();
	}
};

const isUnauth = (to, from, next) => {
	if (auth.loggedIn()) {
		if (from.name == null) {
			next({ name: 'dashboard' });
		} else {
			next({ name: from.name });
		}
	} else {
		next();
	}
};

const routes = [{
	path: '/auth',
	component: () =>
	import ('@/views/layout/Auth.vue'),
	children: [{
		path: 'login',
		name: 'login',
		beforeEnter: isUnauth,
		component: () =>
		import ('@/views/auth/Login.vue'),
	}, {
		path: 'sso/:token',
		name: 'sso',
		component: () =>
		import ('@/views/sso/Sso.vue'),
	}],
}, {
	path: '/',
	component: () =>
	import ('@/views/layout/Main.vue'),
	beforeEnter: isAuth,
	children: [{
		path: '/',
		name: 'dashboard',
		component: () =>
		import ('@/views/dashboard/Dashboard.vue'),
	}, {
		path: '/stock',
		name: 'stock',
		component: () =>
		import ('@/views/stock/Stock.vue'),
	}, {
		path: '/transaction',
		name: 'transaction',
		component: () =>
		import ('@/views/transaction/Transaction.vue'),
	}, {
		path: '/ewallet',
		name: 'ewallet',
		component: () =>
		import ('@/views/ewallet/Ewallet.vue'),
	}, {
		path: '/profile',
		name: 'profile',
		component: () =>
		import ('@/views/setting/Profile.vue'),
	}, {
		path: '/courier',
		name: 'courier',
		component: () =>
		import ('@/views/setting/Courier.vue'),
	}],
}, {
	path: '*',
	beforeEnter: (to, from, next) => {
		next('/')
	}
}]

const router = new VueRouter({
	mode: 'history',
	base: process.env.BASE_URL,
	linkExactActiveClass: 'exact-active',
	linkActiveClass: 'active',
	routes
})

export default router